// Internalizado de @mandae/ng-api 2.13.7 na remoção da dependência.
// Mantidos apenas os métodos usados pelo webapp.
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIConfig } from '../api-config';
import { ShippingOption } from '../models/order';

@Injectable({
  providedIn: 'root'
})
export class ShippingOptionsApiService {
  constructor(private http: HttpClient, private config: APIConfig) { }

  public getShippingOptions(): Observable<ShippingOption[]> {
    return this.http.get<ShippingOption[]>(`${this.config.pedidoApiUrl}/v1/configuracaoopcao`);
  }
}
